import GetCoordinates from "./GetCoordinates";

export default GetCoordinates;
